export default __webpack_public_path__ + "static/media/tyler_headshot.564d215c.jpeg";